import React from "react";
import SvgIcon from "./components/logo";
import "./App.css";
import Footer from "./components/Footer";

const App = () => {
  const slogan = "One Mission. To Ignite Innovation for a Better Tomorrow.";
  const words = slogan.split(" ");
  return (
    <div className="landing-page">
      {/* Full-Screen Logo Section */}
      <section className="logo-section">
        <div className="logo-container">
          <SvgIcon className="logo" />
        </div>
        <div className="slogan-container">
          <p className="slogan">
            {slogan.split(" ").map((word, i) => (
              <span
                key={i}
                className="slogan-word"
                style={{
                  animationDelay: `${0.3 + i * 0.16}s`,
                }}
              >
                {word}
                {i !== words.length - 1 ? (
                  <span className="space">&nbsp;</span>
                ) : null}
              </span>
            ))}
          </p>
        </div>
      </section>

      {/* Phora Section */}
      <section className="phora-section">
        <div className="phora-title">Web Development</div>
        <div className="phora-description">
          <p>
            We build modern websites and web applications for businesses. Clean,
            fast, and responsive on every device.
          </p>
          <p>
            Whether you need a company website, landing page, or a custom web
            app, we handle everything from development to deployment with a
            smooth, reliable delivery.
          </p>
        </div>
      </section>

      {/* About QuasarX Section */}
      <section className="about-quasarx-section">
        <h2>About QuasarX</h2>
        <p>
          QuasarX is a web development studio focused on building modern
          websites and web apps for businesses.
        </p>
        <p>
          We help companies launch clean, responsive sites and custom solutions
          that are easy to use and easy to maintain.
        </p>
        <p>
          From planning to development and deployment, we keep the process
          simple, clear, and reliable with a proper handover when we’re done.
        </p>

        <section className="social-media-section">
          <a
            href="https://www.linkedin.com/company/quasarxai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-linkedin"></i>
          </a>
          <a
            href="https://x.com/QuasarX_ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-x-twitter"></i>
          </a>
          <a
            href="https://www.instagram.com/quasarx.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-instagram"></i>
          </a>
          <a
            href="https://www.tiktok.com/@quasarx.ai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="fab fa-tiktok"></i>
          </a>
        </section>
      </section>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default App;
